import saunaToken from "../abis/production/tokens/saunaToken";

export default {
  name: "SAUNA",
  abi: saunaToken.abi,
  contractAddress: "0x06b889a7a7fa15d8cc7cff147962c4232cce7cf0",
  decimals: 18,
};
